import type { SelectOption } from './types';

export const vehicleTypeSelectOptionConfigs: SelectOption = {
  placeholder: {
    text: 'Vehicle Type',
    isOptionHidden: true,
  },
  optionList: [
    { text: 'Any', value: '' },
    { text: 'Hybrid Cars', value: 'hybrid' },
    { text: 'Electric Cars', value: 'electric' },
    { text: 'Hatchback', value: 'hatchback' },
    { text: 'Luxury Sedan', value: 'luxury' },
    { text: 'MPV', value: 'mpv' },
    { text: 'Mid-Sized Sedan', value: 'sedan' },
    { text: 'Sports', value: 'sports' },
    { text: 'Stationwagon', value: 'stationwagon' },
    { text: 'SUV', value: 'suv' },
    { text: 'All Commercial Vehicles', value: 'commercial' },
    { text: 'All Passenger Cars', value: 'passenger' },
  ],
};

export const categorySelectOptionConfigs: SelectOption = {
  placeholder: {
    text: 'Category',
    isOptionHidden: true,
  },
  optionList: [
    { text: 'Any', value: '' },
    { text: 'Authorised Distributor', value: 'ad' },
    { text: 'Parallel Importer', value: 'pi' },
    { text: 'Cat A COE', value: 'a' },
    { text: 'Cat B COE', value: 'b' },
  ],
};
